import { useEffect, useMemo, useState } from 'react';
import { useAppUpdateAllFilterSelectedValue } from '../../../hooks/filters/use-app-filter-selected-value.hook';
import { useAppFilters } from '../../../hooks/filters/use-app-filters.hook';
import {
  AppFilterContext,
  AppFilterProviderProps,
  FilterContextData,
} from './filter.provider';

/**
 * Loads filters only once. In this case, we don't pass filter selection to get global filters.
 *
 */
export const AppFilterStandAloneProvider = ({
  children,
  filterSelection,
  moduleId,
}: AppFilterProviderProps) => {
  const [ready, setReady] = useState(false);
  const { filters } = useAppFilters([]);
  const updateFilters = useAppUpdateAllFilterSelectedValue();

  useEffect(() => {
    if (filters && filters.length > 0) {
      updateFilters(filters);
      setReady(true);
    }
  }, [filters, updateFilters]);

  const filterContext = useMemo((): FilterContextData => {
    if (filters && filters.length > 0 && ready)
      return {
        filters,
        moduleId,
        ready: ready,
        initialFilterSelection: filterSelection,
      };
    else
      return {
        filters: [],
        moduleId,
        ready: false,
        initialFilterSelection: [],
      };
  }, [filters, moduleId, ready, filterSelection]);
  return (
    <AppFilterContext.Provider value={filterContext}>
      {children}
    </AppFilterContext.Provider>
  );
};
